module.exports = __webpack_public_path__ + "static/media/reduxLogo.4fb46949.svg";